import { useDispatch, useSelector } from "react-redux";
import { API_OPTIONS } from "../../utils/constants";
import { useEffect } from "react";
import { addPopularMovies } from "../../utils/moviesSlice";



const usePopularMovies = () => {
    const dispatch = useDispatch();

    const getPopularMovies = async() => {
      const data = await   fetch("https://api.themoviedb.org/3/movie/top_rated?&page=1", API_OPTIONS)
      const json = await data.json();
      console.log(json.results)
      dispatch(addPopularMovies(json.results));
    }
  
    useEffect(() => {
    //   getPopularMovies();
   getPopularMovies();
  
    },[])
}

export default usePopularMovies;


